import { render, staticRenderFns } from "./Duplicates.vue?vue&type=template&id=12c508ed&scoped=true"
import script from "./Duplicates.vue?vue&type=script&lang=js"
export * from "./Duplicates.vue?vue&type=script&lang=js"
import style0 from "./Duplicates.vue?vue&type=style&index=0&id=12c508ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c508ed",
  null
  
)

export default component.exports